/** Horizontally scrollable category tabs — Showroom underline style. */
interface Props {
  categories: string[];
  active: string | null;
  onSelect: (category: string) => void;
}

export function CategoryTabs({ categories, active, onSelect }: Props): JSX.Element {
  return (
    <div className="flex gap-5 overflow-x-auto border-b border-slate-100 bg-ground px-4">
      {categories.map((c) => {
        const isActive = c === active;
        return (
          <button
            key={c}
            type="button"
            onClick={() => onSelect(c)}
            className={`relative shrink-0 whitespace-nowrap pb-2.5 pt-1 text-[13px] font-semibold transition-colors ${
              isActive ? 'text-ink' : 'text-slate-400'
            }`}
          >
            {c}
            {isActive ? (
              <span className="absolute inset-x-0 -bottom-px h-[2.5px] rounded-t bg-ink" />
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
